/* eslint-disable import/prefer-default-export */
import { findComponentByFieldName } from '../../Helpers/components';

export const isHiddenTrustedFormQuestionPresentOnThisForm = (
  components,
  trustedFormIdentifiers
) => {
  return trustedFormIdentifiers.some((trustedFormIdentifier) => {
    const componentOrError = findComponentByFieldName(
      trustedFormIdentifier,
      '',
      components
    );
    return !!(componentOrError && !componentOrError.errorObject);
  });
};
